export default "__VITE_ASSET__BPrskEsG__"